import { useSubscribeLoaderData } from "./subscribeLoader.ts";
import { useEffect } from "react";
import useSingleToast from "../../root/core-ui/toast/useSingleToast.ts";
import { FormattedMessage } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";
import Toast from "../../../common/core-ui/Toast.tsx";

export default function SubscribeMain() {
  const result = useSubscribeLoaderData();
  const [showToast] = useSingleToast();
  const navigate = useNavigate();
  const params = useParams();

  const email = params.email!;

  useEffect(() => {
    if (result.ok) {
      const message = email.includes("@placeholder") ? (
        <FormattedMessage defaultMessage="Successfully followed user" />
      ) : (
        <FormattedMessage
          defaultMessage="Now following {email}"
          values={{ email }}
        />
      );
      showToast(<Toast type="success" title={message}></Toast>);
    } else {
      showToast(
        <Toast
          type="error"
          title={
            <FormattedMessage
              defaultMessage="Failed to subscribe to {email}, please try again"
              values={{ email }}
            />
          }
        ></Toast>
      );
    }

    void navigate("/dashboard");
  }, [result, showToast, navigate, email]);

  return null;
}
